import { Pipe, PipeTransform } from '@angular/core';
import { TabloTextConfigOptions } from '@ui/tablo-generator/types';

export const getTabloYearDetails = (value: TabloTextConfigOptions): string => {
  if (!value?.addYearToGroupName) {
    return '';
  }

  // if we are before 1st of September add ${previousYear}/${currentYear}
  const now = new Date();
  const currentYear = now.getFullYear();
  const previousYear = currentYear - 1;
  const month = now.getMonth();
  const day = now.getDate();

  if (month < 8 || (month === 8 && day < 1)) {
    return `${previousYear} / ${currentYear}`;
  }

  return `${currentYear} / ${currentYear + 1}`;
};

@Pipe({
    name: 'addYearDetails',
    standalone: false
})
export class AddYearDetailsPipe implements PipeTransform {
  transform(value: TabloTextConfigOptions): string {
    const yearDetails = getTabloYearDetails(value);
    return yearDetails ? ` ${yearDetails}` : '';
  }
}
